@if (showCookieConsentPopup) {
  <div class="cookie-consent-container">
    <div class="cookie-consent-option-popup">
      <div class="cookie-consent-description">
        <!-- <p>
        We are migrating all Diversey email's to Solenis email.
        It is necessary to change your email address to Solenis'.
        <br>
          Do you wish to do it now?
          &nbsp;
          You can also do it under the menu option 'Update Email'.
        </p> -->
        <p>
          We are in the process of migrating {{ isSolenisMigrationEmail ? solenisMigrationEmailSource?.name: ''}} emails to Solenis email accounts.
          Updating your email address to Solenis is essential.
          <br>
            Would you prefer to make this change now?
            <br>
              Alternatively, you can also update it through the 'Update Email' option in the menu.
            </p>
          </div>
          <br> <br> <br>
          <div class="cookie-consent-option-btns">
            <button class="btn btn-accept-all" (click)="proceedClick()">Proceed</button>
            <button class="btn btn-customize" (click)="remindLaterClick()">Remind me Later</button>
          </div>
        </div>
      </div>
    }